"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BasicOfferHint = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _Header = require("../Header");
var _Item = require("../Item");
var _Section = require("../Modal/Section");
var _OfferAction = require("../OfferAction");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const BasicOfferHint = (param)=>{
    let { offer } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { benefits: rawBenefits, offerId, products, purchases, totalPrice } = offer;
    const benefits = rawBenefits !== null && rawBenefits !== void 0 ? rawBenefits : [];
    const onAddOfferFailedCallback = (0, _hooks.useAddBasicOfferHintError)();
    const { addOfferHandler, isAdding } = (0, _hooks.useAddBasketOffer)(offerId, onAddOfferFailedCallback);
    const handleAddBasicOffer = (0, _react.useCallback)(async ()=>{
        await addOfferHandler();
    }, [
        addOfferHandler
    ]);
    const { addedItemTitle, buy, description, getOffer, headerTitle } = (0, _hooks.useBasicOfferHintTranslations)({
        purchases
    });
    (0, _logger.logDebug)('>>> rendering basic offer hint', offerId);
    (0, _logger.logDebug)("Original data in offer ".concat(offerId, ":\n	"), offer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.OfferHintWrapper, {
        "data-testid": getTestId("offer-".concat(offerId)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Header.Header, {
                title: headerTitle,
                description: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.Content, {
                "data-testid": getTestId('offer-content'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Item.AddedItemWrapper, {
                        "data-testid": getTestId('purchases-wrapper'),
                        title: addedItemTitle,
                        children: purchases.map((purchase)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Item.ItemRow, {
                                isPurchased: true,
                                "data-testid": getTestId("purchase-item-".concat(purchase.itemCode)),
                                ...purchase,
                                selectedQuantity: purchase.quantity
                            }, "purchase-item-".concat(purchase.itemCode)))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        "data-testid": getTestId('products-benefits-wrapper'),
                        children: [
                            products.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Section.ModalSection, {
                                title: buy,
                                children: products.map((product)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Item.ItemRow, {
                                        "data-testid": getTestId("product-item-".concat(product.itemCode)),
                                        ...product,
                                        selectedQuantity: product.quantity
                                    }, "product-item-".concat(product.itemCode)))
                            }),
                            benefits.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Section.ModalSection, {
                                title: getOffer,
                                children: benefits.map((benefit)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Item.ItemRow, {
                                        isBenefit: true,
                                        "data-testid": getTestId("benefit-item-".concat(benefit.itemCode)),
                                        ...benefit,
                                        isPurchased: false,
                                        selectedQuantity: benefit.quantity
                                    }, "benefit-item-".concat(benefit.itemCode)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferAction.OfferAction, {
                        isAdding: isAdding,
                        totalPrice: totalPrice,
                        onAddOffer: handleAddBasicOffer
                    })
                ]
            })
        ]
    });
};
exports.BasicOfferHint = BasicOfferHint;
